export const stripTrailingSlash = (path) => {
  return (path || "").replace(/(.+)\/$/, "$1")
}
